import { render } from "./dragVerify.vue?vue&type=template&id=f11ed0e4&scoped=true"
import script from "./dragVerify.vue?vue&type=script&lang=js"
export * from "./dragVerify.vue?vue&type=script&lang=js"

import "./dragVerify.vue?vue&type=style&index=0&id=f11ed0e4&scoped=true&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f11ed0e4"]])

export default __exports__